import { observable } from 'rewire-core';

export interface IDashboardElementProps {
  name: string;
  value: number;
  maxValue: number;
  formattedValue?: string;
  enabled: boolean;
  uri: string;
  color: string;
  visible: boolean;
}

const formatter = new Intl.NumberFormat('en-US');

export default class DashboardElementModel {
  state: IDashboardElementProps;

  constructor(
    name: string,
    value: number,
    maxValue: number,
    enabled: boolean,
    uri: string,
    color: string = '#0f5c71',
    visible: boolean = true,
  ) {
    this.state = observable({ name, value, maxValue, enabled, uri, color, visible });
  }

  public get name(): string {
    return this.state.name;
  }

  public get value(): number {
    return this.state.value;
  }

  public set value(value: number) {
    this.state.value = value;
  }

  public get visible(): boolean {
    return this.state.visible;
  }

  public set visible(value: boolean) {
    this.state.visible = value;
  }

  public get maxValue(): number {
    return this.state.maxValue;
  }

  public set maxValue(value: number) {
    this.state.maxValue = value;
  }

  public get formattedValue(): string {
    return formatter.format(this.value);
  }

  public get uri(): string {
    return this.state.uri;
  }

  public set uri(value: string) {
    this.state.uri = value;
  }

  public get color(): string {
    return this.state.color;
  }

  public get enabled(): boolean {
    return this.state.enabled;
  }

  public set enabled(value: boolean) {
    this.state.enabled = value;
  }
}
